"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var isHotReloading = function isHotReloading() {
  var castModule = module;
  return !!(typeof castModule !== 'undefined' && castModule.hot && typeof castModule.hot.status === 'function' && castModule.hot.status() === 'apply');
};

var _default = isHotReloading;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/util/isHotReloading.js
 ** module id = 670
 ** module chunks = 0 1
 **/